import React from 'react'
import { TextLink } from 'baby-design'
import { settingsRegistryPath } from 'lib/urls'
import css from './ArrivalDateBanner.styles.scss'

const ArrivalDateBanner: React.FC = () => (
  <div className={css.ArrivalDateBanner}>
    <span className={css.ArrivalDateBanner__title}>No gifts left behind!</span>
    <span
      className={css.ArrivalDateBanner__body}
      data-testid="ArrivalDateBanner-body"
    >
      We will automatically use standard shipping 14 days before your{' '}
      <TextLink
        underline
        href={settingsRegistryPath}
        innerContentClassName={css.ArrivalDateBanner__body__link}
        size="sm"
      >
        arrival date
      </TextLink>
      .
    </span>
  </div>
)

export default ArrivalDateBanner
